import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import appConfig from '../../../config.js';
import Table from '../../commons/Table/Table';
import Modal from '../../commons/Modal/Modal';
import { InputField, SelectField } from '../../commons/Inputs';
import FloatingActionButton from '../../commons/Buttons/FloatingActionButton';

import {
    getPractitionersApi
} from '../../actions/practitioners';
import { isObject } from 'lodash';

// let App = window.App;
let $ = window.jQuery;

class Accounts extends Component {
    static propTypes = {
        getPractitionersApi: PropTypes.func.isRequired,
        session: PropTypes.object.isRequired
    };

    state = {
        data : [],
        headers : [
            {key : 'name', label : 'Practitioner'},
            // {key : 'role', label : 'Role'},
            {key : 'user_type_id', label : 'Account Type'},
            {key : 'actions', label : 'Actions'},
            {key : 'id', label: 'id'}
        ],
        isSavingAccount : false,
        isEditingAccount: false,
        selectedAccount : {
            'id': '',
            'firstname': '',
            'middlename': '',
            'lastname': '',
            'gender': '',
            'email': '',
            'role': '',
            'user_type_id': '',

            // for practitioners
            'prc': '',
            'ptr': '',
            's2_license': ''
        },
        gender: [
            {value:'',label:'Select...'},
            {value:'1',label: 'Male'},
            {value:'0',label: 'Female'}
        ],
        accountTypes: [
            {value:'',label:'Select...'},
            {value:'9',label:'Dentist'},
            {value:'10',label:'Sub-Dentist'},
            {value:'3',label:'Staff'}
        ],
        errors: []
    };

    handleFABClick = () => {
        $('#accountModal').modal('show');
    };

    generateTableActions = (id) => {
        return (
            <div className="">
                <button href="#"
                        className='btn btn-xs tooltips blue'
                        data-container="body"
                        data-placement="top"
                        data-original-title='Edit'
                        onClick={this.handleEditAccount}
                        data-id={id}>
                    <i className='glyphicon glyphicon-edit'
                       data-id={id} />
                </button>
                <button href="#"
                        className='btn btn-xs tooltips deletePopover red'
                        data-container="body"
                        data-placement="top"
                        data-original-title='Delete'
                        data-id={id}
                        data-toggle="confirmation"
                        data-singleton="true">
                    <i className='glyphicon glyphicon-remove'
                       data-id={id} />
                </button>
            </div>
        );
    };

    getAllAccounts = () => {
        let url = appConfig.apiUrl + 'management/accounts';

        axios({
            url: url,
            timeout: 20000,
            method: 'get'
        }).then((res) => {
            let displayData = res.data.data.accounts;

            displayData.forEach((row) => {
                //console.log(row);
                row.name = row.firstname +' '+ row.lastname;
                // row.role = "";
                row.user_type_id = row.user_types.name;

                // if(row.practitioner != null) {
                //     row.user_type_id = "Dentist";
                // } else if (row.staff != null) {
                //     row.user_type_id = "Staff";
                // } else {
                //     row.user_type_id = "Something else...";
                // }


                // add actions
                row.actions = this.generateTableActions(row.id);
            });

            this.setState({
                data : displayData
            }, (e) => {
                $('#table').dataTable({
                    "columnDefs": [
                        {
                            "targets": [3], //id
                            "visible": false,
                            "searchable": false
                        }
                    ],
                    "order": [[ 3, 'desc' ]]
                });
                $('.tooltips').tooltip();

                let self = this;

                $('.deletePopover').confirmation({
                    title: 'Are you sure to delete this Account?',
                    popout: true,
                    btnOkClass: 'btn btn-primary btn-sm',
                    btnCancelClass: 'btn btn-danger btn-sm',
                    container: 'body',
                    onConfirm: function() {
                        let accountId = $(this).data('id');
                        self.deleteAccount(accountId);
                    }
                });
            });

            this.props.getPractitionersApi();
        }).catch((res) => {
            // display error
        });
    };

    handleSaveAccount = () => {
        // disable modal buttons
        this.setState({
            isSavingAccount : true,
        });
        let url = appConfig.apiUrl + (this.state.isEditingAccount ? 'management/accounts/'+this.state.selectedAccount.id : 'management/accounts');
        let account = $('#accountForm').serializeArray();
        if(this.state.isEditingAccount === true) {
            account.push({name: '_method', value: 'PUT'});
        }

        axios({
            url: url,
            timeout: 20000,
            method: 'post',
            data: window.jQuery.param(account)
        }).then((res) => {

            // enable modal buttons again
            this.setState({
                isSavingAccount : false
            }, (e) => {
                // destroy table
                $('#table').dataTable().fnDestroy();

                // refresh table
                this.getAllAccounts();
            });

            // clear form
            this.setState({
                isEditingAccount: false,
            }, (e) => {

                // close modal
                $('#accountModal').modal('toggle');
                this.clearForm();
            })
        }).catch((error) => {
            let fields = []
            if (isObject(error.response.data.errors)) {
                fields = Object.keys(error.response.data.errors);
            } else {
                this.props.showNotification('error', error.response.data.errors);
            }
            let errors = this.state.errors;
            fields.forEach((item) => {
                errors[item] = true;
            });

            this.setState({
                errors,
                isSavingAccount : false
            });

        });
    };

    handleEditAccount = (e) => {
        let id = parseInt(e.target.dataset.id, 10);
        let index = this.state.data.findIndex((item) => item.id === id);
        let account = this.state.data[index];

        if(account) {
            this.setState({
                isEditingAccount : true,
                selectedAccount : {
                    'id': account.id,
                    'firstname': account.firstname,
                    'middlename': account.middlename,
                    'lastname': account.lastname,
                    'gender': account.gender,
                    'email': account.user_emails[0].email,
                    'role': '',
                    'user_type_id': account.practitioner != null ? 1 : 3,

                    // for practitioners
                    'prc': account.practitioner != null ? account.practitioner.prc : '',
                    'ptr': account.practitioner != null ? account.practitioner.ptr : '',
                    's2_license': account.practitioner != null ? account.practitioner.s2_license : ''
                }
            }, (e) => {
                $('#accountModal').modal('toggle');
            })
        }
    };

    deleteAccount = (id) => {
        let url = appConfig.apiUrl + 'management/accounts/'+id;

        axios({
            url: url,
            timeout: 20000,
            method: 'post',
            data: {'_method': 'DELETE'}
        }).then((res) => {

            // destroy table
            $('#table').dataTable().fnDestroy();

            // refresh table
            this.getAllAccounts();
        }).catch((res) => {
            // display error
        });
    };

    handleCloseModal = () => {
        this.clearForm();
    };

    clearForm = () => {
        this.setState({
            isEditingAccount: false,
            selectedAccount : {
                'id': '',
                'firstname': '',
                'middlename': '',
                'lastname': '',
                'gender': '',
                'email': '',
                'role': '',
                'user_type_id': '0',

                // for practitioners
                'prc': '',
                'ptr': '',
                's2_license': ''
            }
        });
    };

    componentDidMount() {
        this.getAllAccounts();
    }

    render() {
        return(
            <div className="page-content">

                <div className="row">
                    <div className="col-md-8">
                        <h3 className="page-title">
                            Management &nbsp; <small>Accounts</small>
                        </h3>
                    </div>
                </div>

                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="portlet light portlet-fit">
                        <div className="portlet-title">
                            <div className="caption">
                                <i className=" icon-bar-chart font-blue" />
                                <span className="caption-subject font-blue sbold uppercase">Accounts</span>
                            </div>
                        </div>
                        <div className="portlet-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-scrollable">
                                        <Table id={"table"} headers={this.state.headers} data={this.state.data} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <FloatingActionButton
                            title="Add Account"
                            onClick={this.handleFABClick} />
                    </div>
                </div>

                <Modal
                    id="accountModal"
                    header="Add Account"
                    onNegativeClickEvent={this.handleCloseModal}
                    onPositiveClickEvent={this.handleSaveAccount}
                    isSaving={this.state.isSavingAccount}>

                    <div className="row">
                        <div id="alert-modal-container-account" style={{ paddingRight: '20px', paddingLeft: '20px' }}></div>

                        <div className="col-md-12">
                            <form id="accountForm">
                                <div className="row">
                                    <div className="col-md-3">
                                        <InputField val={this.state.selectedAccount.firstname}
                                                    id="firstname"
                                                    label="First name"
                                                    help=""
                                                    type="text"
                                                    hasError={this.state.errors.firstname} />
                                    </div>
                                    <div className="col-md-3">
                                        <InputField val={this.state.selectedAccount.middlename}
                                                    id="middlename"
                                                    label="Middle name"
                                                    help=""
                                                    type="text"
                                                    hasError={this.state.errors.middlename} />
                                    </div>
                                    <div className="col-md-3">
                                        <InputField val={this.state.selectedAccount.lastname}
                                                    id="lastname"
                                                    label="Last name"
                                                    help=""
                                                    type="text"
                                                    hasError={this.state.errors.lastname} />
                                    </div>
                                    <div className="col-md-3">
                                        <SelectField val={this.state.selectedAccount.gender}
                                                     id="gender"
                                                     label="Gender"
                                                     help=""
                                                     options={this.state.gender}
                                                     hasError={this.state.errors.gender} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <SelectField val={this.state.selectedAccount.user_type_id}
                                                     id="user_type_id"
                                                     label="Account Type"
                                                     help=""
                                                     options={this.state.accountTypes}
                                                     hasError={this.state.errors.user_type_id} />
                                    </div>
                                    <div className="col-md-4">
                                        <InputField val={this.state.selectedAccount.email}
                                                    id="email"
                                                    label="Email"
                                                    help=""
                                                    type="text"
                                                    hasError={this.state.errors.email} />
                                    </div>
                                    <div className="col-md-4">
                                        <InputField val=""
                                                    id="password"
                                                    label="Password"
                                                    help=""
                                                    type="password"
                                                    hasError={this.state.errors.password} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <InputField val={this.state.selectedAccount.prc}
                                                    id="prc"
                                                    label="PRC License"
                                                    help=""
                                                    type="text"
                                                    hasError={this.state.errors.prc} />
                                    </div>
                                    <div className="col-md-4">
                                        <InputField val={this.state.selectedAccount.ptr}
                                                    id="ptr"
                                                    label="PTR License"
                                                    help=""
                                                    type="text"
                                                    hasError={this.state.errors.ptr} />
                                    </div>
                                    <div className="col-md-4">
                                        <InputField val={this.state.selectedAccount.s2_license}
                                                    id="s2_license"
                                                    label="S2 License"
                                                    help=""
                                                    type="text"
                                                    hasError={this.state.errors.s2_license} />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        session: state.session
    }
};

export default connect(mapStateToProps, {
    getPractitionersApi
})(Accounts);


/** WEBPACK FOOTER **
 ** ./src/containers/Accounts/index.js
 **/